export const APPLE_MURDERER_ROOT_PATH = "/the-apple-murderer";
